import React, { useState, useEffect } from "react"
import * as style from "./style.module.css"

function Component() {
  const [scrollProgress, setScrollProgress] = useState(0)

  useEffect(() => {
    if (typeof window === "undefined") return // Window check.

    const handleScroll = () => {
      const totalHeight =
        document.documentElement.scrollHeight - window.innerHeight
      const scrolled = window.scrollY
      const progress = (scrolled / totalHeight) * 100
      setScrollProgress(progress)
    }

    if (typeof window !== "undefined") {
      window.addEventListener("scroll", handleScroll)
    }

    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("scroll", handleScroll)
      }
    }
  }, [])

  const scrollProgressBarWidthStyle = {
    height: "4px",
    width: `${scrollProgress}%`,
    backgroundColor: "var(--ccolor-main-black)",
    transition: "width 0.2s ease",
  }

  return (
    <div
      style={scrollProgressBarWidthStyle}
      className={style.scrollProgressBar}
    />
  )
}

export default Component
